/* eslint-disable @typescript-eslint/no-unused-vars */
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

export const CustomerListAudiencePanelView = globalContext.define(
  [
    '@bingads-webui/i18n-amd-loader!campaignui/feature/audiences',
    'PageContext',
    'component/azure-upload/index',
  ],
  Promise => import(/* webpackMode: 'eager' */ './src/index') // eslint-disable-line no-unused-vars
);

export const AudienceDetailPanel = globalContext.define(
  [],
  Promise => import(/* webpackMode: 'eager' */ './src/detail-panel/detail-panel') // eslint-disable-line no-unused-vars
);

export const UploadSelector = globalContext.define(
  [],
  Promise => import(/* webpackMode: 'eager' */ './src/detail-panel/upload-selector') // eslint-disable-line no-unused-vars
);

export const ActionSelector = globalContext.define(
  [],
  Promise => import(/* webpackMode: 'eager' */ './src/detail-panel/action-selector') // eslint-disable-line no-unused-vars
);

export const CustomerListFilePicker = globalContext.define(
  [],
  Promise => import(/* webpackMode: 'eager' */ './src/detail-panel/file-picker') // eslint-disable-line no-unused-vars
);

export const ResultPanel = globalContext.define(
  [],
  Promise => import(/* webpackMode: 'eager' */ './src/result-panel/result-panel') // eslint-disable-line no-unused-vars
);
